import { _request } from '@@/utils/request'
import CONFIG from '@@/config'

export const {
  HQPCBA_HOST
} = CONFIG

export const pcbaRequest = {
  get: (url, data, config = {}) => _request.get(`${HQPCBA_HOST}${url}`, data, {...config}),
  post: (url, data, config = {}) => _request.post(`${HQPCBA_HOST}${url}`, data, {...config})
}

// PCBA下单参数加/解密字段
const PCBA_PARAMS_CRYPTO_KEYS = [
  // address
  ...(['addr', 'combinAddr', 'consignee', 'idNum', 'telMobile'].map(item => `address.${item}`)),
  // invoice
  ...(['invoiceAddress', 'invoiceCityText', 'invoiceDistrictText', 'invoiceMobile', 'invoiceProvinceText', 'invoiceTitle', 'taxAddr', 'taxBank', 'taxBankAccount', 'taxCode', 'taxTel',].map(item => `invoice.${item}`)),
  // order_info
  ...(['add_user', 'add_user_email', 'add_user_tel', 'deliver_email', 'pickup_phone', 'pickup_uname'].map(item => `order_info.${item}`)), 
  // pcb_params
  'pcb_params'
]

// 初始化BOM自助选型
export const bomInitialization = data => pcbaRequest.post('/pcba/app/bom/initialization', data, {
  reqCryptoKeys: PCBA_PARAMS_CRYPTO_KEYS.map(item => `pricingReq.${item}`)
})

// 获取pcb订单列表
export const getPcbOrdersToBind = data => pcbaRequest.post('/pcba/app/pcb/getPcbOrdersToBind', data)

// 获取BOM订单列表
export const getBomOrdersToBind = data => pcbaRequest.post('/pcba/app/bom/getBomOrdersToBind', data)

// 获取PCBA计价
export const getPcbaPrice = data => pcbaRequest.post('/pcba/app/tools/getPricing', data, {
  reqCryptoKeys: PCBA_PARAMS_CRYPTO_KEYS
})

// 获取PCBA快递列表
export const getPcbaExpress = data => pcbaRequest.post('/pcba/app/tools/expressList', data)

// PCBA订单临时存储
export const saveOrderTemp = data => pcbaRequest.post('/pcba/app/temp/save', data, {
  reqCryptoKeys: PCBA_PARAMS_CRYPTO_KEYS
})

// 获取PCBA订单临时数据
export const getOrderTemp = data => pcbaRequest.post('/pcba/app/temp/detail', data, {
  resultKey: 'result',
  resCryptoKeys: PCBA_PARAMS_CRYPTO_KEYS
})

// BOM匹配后数据查看
export const checkBomMatchItem = data => pcbaRequest.post('/pcba/app/bom/checkBomMatchItem', data)

// BOM匹配后数据查看
export const bomSmtTemplateDownload = data => pcbaRequest.post('/pcba/app/bom/bomSmtTemplateDownload', data)

// 提交PCBA订单
export const submitPcbaOrder = data => pcbaRequest.post('/pcba/app/oneStop/saveDemand', data, {
  reqCryptoKeys: PCBA_PARAMS_CRYPTO_KEYS
})

// 获取返单资料信息
export const getReOrderParams = data => pcbaRequest.post('/pcba/app/demand/getReOrderParams', data)

// 校验PCB是否能返单
export const checkPcbReturnOrder = data => pcbaRequest.post('/pcba/app/demand/checkPcbReturnOrder', data)

// 返单生成需求单
export const savePcbaReturnOrder = data => pcbaRequest.post('/pcba/app/demand/saveReturnOrder', data, {
  reqCryptoKeys: PCBA_PARAMS_CRYPTO_KEYS
})

// 获取PCBA暂存订单
export const getPcbaRestoreOrder = data => pcbaRequest.post('/pcba/app/temp/storage', data)

// 获取SMT微信公众号信息
export const getSmtOffiaccount = () => pcbaRequest.get('/pcba/app/weChat/getQrcode')

export const getPcbOrderInfo = (data) => pcbaRequest.post('/pcba/app/pcb/getPcbOrderInfo',data)

// DFM-PCB文件解析焊点
export const pushPcbFileAnalysis = (data) => pcbaRequest.post('/pcba/app/dfm/pushPcbFileAnalysis',data)

export const getCamSolderJoint = (data) => pcbaRequest.post('/pcba/app/dfm/getCamSolderJoint',data)

// SMT新客现金券弹框查询
export const getSmtNewUserVoucherPopup = () => pcbaRequest.post('/pcba/app/activity/smtNewUserVoucherPopup')
// SMT新客现金券领取
export const claimSmtNewUserVoucher = () => pcbaRequest.post('/pcba/app/activity/smtNewUserActivityVoucherClaim')
